<template>
  <div class="">
    <slide-over-panel v-if="zone !== null"
                v-model:show="$data._show"
                @update:show="updateShow($data._show)">
      <template #title>
        <div class="flex items-center">
          <span>Zone Groups</span>
        </div>
      </template>

      <template #content>

        <div class="">
          <span class="text-lg text-gray-900 text-left font-semibold">Area</span>
        </div>

        <div class="">
          <span class="text-lg text-gray-900 text-left">{{ zone.area }}</span>
        </div>

        <div class="mt-6">
          <span class="text-lg text-gray-900 text-left font-semibold">Zone</span>
        </div>
        <div class="">
          <span class="text-lg text-gray-900 text-left">{{ zone.zone }}</span>
        </div>

        <div class="mt-4 pb-4"
             v-show="$data._show">
          <span class="text-lg text-gray-900 text-left font-semibold">Groups</span>
          <!--                  Note: We purposely don't v-model the groupUsersArray, we just v-bind it since it's computed -->
          <select2
              :value="groupsArray"
              :options="availableGroupsArray"
              :multiple="true"
              :name="'groupsOnZone'"
              @input="updateGroups"
          >
          </select2>
        </div>

        <green-button @click="save"
        >
          <div v-if="processing"
               class="inline-flex">
            <span class="lnr icon-loading animate-spin" style="font-size: 1.2rem;"></span>
            <span class="pl-4">Processing</span>
          </div>
          <div v-else
               class="inline-flex">
            <span>Save Changes</span>
          </div>
        </green-button>

      </template>
    </slide-over-panel>

    <!--    Notification modal for the results -->
    <notification-modal
        v-model:is-open="showResultModal"
    >
      <template #title-content>
        Update Successful!
      </template>
      {{ modalText }}
    </notification-modal>

  </div>
</template>

<script>

import axios from "axios"
import {SonicuCoreMixin} from "@/mixins/SonicuCoreMixin";
import {iconNamesMixin} from '@/mixins/IconNamesMixin';
import SlideOverPanel from '@/components/elements/SlideOverPanel';
import GreenButton from '@/components/elements/green-button';
import SmallColoredCheck from "@/components/elements/SmallColoredCheck";
import Select2 from '@/components/elements/select2';
import ButtonRedPrimary from "@/components/elements/buttons/ButtonRedPrimary";
import ButtonAjax from "@/components/elements/buttonAjax";
import NotificationModal from "@/components/elements/NotificationModal";
import SonicuButton from "@/components/elements/buttons/SonicuButton";

export default {
  name: "GroupPermissionsEdit",
  mixins: [SonicuCoreMixin, iconNamesMixin],
  components: {
    SonicuButton,
    NotificationModal, ButtonAjax, ButtonRedPrimary, SmallColoredCheck, SlideOverPanel, GreenButton, Select2},
  props: {
    zone: Object,
    show: Boolean,
  },
  data() {
    return {
      _show: this.show,
      groupsToSubmit: {},
      processing: false,
      showResultModal: false,
      showConfirmModal: false,
      modalText: '',
      groupPermissions: {}
    }
  },
  created() {
  },
  mounted() {

  },
  methods: {
    updateShow(show) {
      this.$data._show = show
      this.$emit('update:show', this.$data._show)
    },
    save() {
      console.log('saving');
      console.log(this.groupsToSubmit);
      this.processing = true;
      axios.post(this.company.buildCompanyApiInternalRoute('group-permissions'), {
        zone_id: this.zone.zone_id,
        groups: this.groupsToSubmit,
      }).then(response => {
          this.isAddingGroup = false;
          this.modalText = 'Zone groups updated successfully!'
          this.showResultModal = true;
         this.updateAvailableZones();
          console.log('groups to sybmit');
          console.log(this.groupsToSubmit);
          this.$emit('update:zoneGroups', this.groupPermissions);
          this.processing = false;
          }
      ).catch(error => {
        this.processing = false;
      })

    },
    updateGroups() {
      let newGroups = [];
      let elementName = "groupsOnZone"
      let val = $('[name=' + elementName + ']').val()
      val.forEach((item) => {
        newGroups.push(parseInt(this.availableGroupsIDsArray[item]));
      })
      this.groupsToSubmit = newGroups;
    },
    updateAvailableZones(){
      console.log('updateAvailableZones');
      console.log(this.groupPermissions);
      var i = 0;
      for (const[key, value] of Object.entries(this.groupPermissions.available_groups)){
        console.log(value[0]);
        console.log((Object.values(this.groupsToSubmit)));
        console.log(Object.values(this.groupsToSubmit).includes(value[0]));
        if(Object.values(this.groupsToSubmit).includes(value[0])){
          console.log(Object.keys(this.groupsToSubmit));
          console.log(value);
          this.groupPermissions.available_groups[i][2] = true;
        }
        else{
          this.groupPermissions.available_groups[i][2] = false;
        }
        i++;
      }

      console.log('post update');
      console.log(this.groupPermissions);
    }
  },
  computed: {
    getGroupIDs(){
      var groupIDs = []
      for (const[key, value] of Object.entries(this.groupPermissions.available_groups)){
        if(value[2]) {
          groupIDs.push(value[0]);
        }
      }
      return groupIDs;
    },
    groupsArray() {
      var groupIndex = []
      var i = 0;
      for (const [key, value] of Object.entries(this.zone.available_groups)) {
          if (value[2]) {
            groupIndex.push(i);
          }
        i++;
      }
      return groupIndex;
    },
    availableGroupsArray() {
      var groupIDs = []
      for (const [key, value] of Object.entries(this.zone.available_groups)) {
        groupIDs.push(value[1]);
      }
      return groupIDs;
    },
    availableGroupsIDsArray() {
      var groupIDs = []
      for (const [key, value] of Object.entries(this.zone.available_groups)) {
        groupIDs.push(value[0]);
      }
      return groupIDs;
    }
  },
  watch: {
    show() {
      this.$data._show = this.show;
    },
    zone: function (newVal, oldVal) {
      console.log('updating');
      console.log(newVal);
      console.log(oldVal);
      this.groupPermissions = _.clone(newVal);
    },
    showResultModal: function(newVal, oldVal) {
      if(newVal === false){
        this.updateShow(false);
      }
    }
  },
}

</script>

<style scoped>

</style>